<div class="encabezado">
  <h5 class="titulo1">{{ "titles-menu-pages.reports" | translate }}</h5>
  <div class="menu-horizontal">
    <button
      *ngFor="let boton of botones; let i = index"
      [class.selected]="i === botonSeleccionado"
      (click)="seleccionarBoton(i)"
    >
      {{ boton | translate }}
    </button>
  </div>
  <!-- Tab 0: Prescripciones -->
  <ng-container *ngIf="botonSeleccionado === 0">
    <div class="row">
      <div class="col-6">
        <a [routerLink]="['/reports', 'prescription-broker', 'contracts']">
          <div class="setting-card" (click)="changeOpt()">
            <div class="iconleft">
              <i class="icon-clipboard-text"></i>
            </div>
            <div class="text">
              <h3>{{ "reports.contracts" | translate }}</h3>
              <a class="text_see_reports"
                >{{ "reports.see-reports" | translate }}
              </a>
            </div>
            <div class="iconright">
              <i class="icon-chevron-right"></i>
            </div>
          </div>
        </a>
      </div>

      <div class="col-6">
        <a [routerLink]="['/reports', 'prescription-broker', 'after-sales']">
          <div class="setting-card" (click)="changeOpt()">
            <div class="iconleft">
              <i class="icon-clipboard-check"></i>
            </div>
            <div class="text">
              <h3>{{ "reports.after-sales" | translate }}</h3>
              <a class="text_see_reports"
                >{{ "reports.see-reports" | translate }}
              </a>
            </div>
            <div class="iconright">
              <i class="icon-chevron-right"></i>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <a [routerLink]="['/reports', 'prescription-broker', 'evolution']">
          <div class="setting-card" (click)="changeOpt()">
            <div class="iconleft">
              <i class="icon-signal"></i>
            </div>
            <div class="text">
              <h3>{{ "reports.evolution" | translate }}</h3>
              <a class="text_see_reports"
                >{{ "reports.see-reports" | translate }}
              </a>
            </div>
            <div class="iconright">
              <i class="icon-chevron-right"></i>
            </div>
          </div>
        </a>
      </div>
      <div class="col-6">
          <a
            [routerLink]="[
              '/reports',
              'prescription-broker',
              'evolution_campaign_stock'
            ]"
          >
            <div class="setting-card" (click)="changeOpt()">
              <div class="iconleft">
                <i class="icon-bullhorn"></i>
              </div>
              <div class="text">
                <h3>{{ "reports.evolution_campaign" | translate }}</h3>

                <a class="text_see_reports"
                  >{{ "reports.see-reports" | translate }}
                </a>
              </div>
              <div class="iconright">
                <i class="icon-chevron-right"></i>
              </div>
            </div>
          </a>
        </div>
      <div class="row">
        <div *ngIf="opt" class="container-fluid">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Tab 1: No entregados (solo brokers) -->
  <ng-container *ngIf="botonSeleccionado === 1">
    <div class="row">
      <div class="col-6">
        <a [routerLink]="['/reports', 'not-delivered', 'tokens']">
          <div class="setting-card" (click)="changeOpt()">
            <div class="iconleft">
              <i class="icon-truck"></i>
            </div>
            <div class="text">
              <h3>{{ "reports.not_delivered" | translate }}</h3>
              <a class="text_see_reports"
                >{{ "reports.see-reports" | translate }}
              </a>
            </div>
            <div class="iconright">
              <i class="icon-chevron-right"></i>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="row">
      <div *ngIf="opt" class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-container>
</div>
